"use client";

import { toast } from "sonner";

const useToast = () => {
  const showSuccess = (message: string) => {
    toast.success(message, {
      description: " ",
      duration: 3000, 
    });
  };

  const showError = (message: string) => {
    toast.error(message, {
      description: " ",
      duration: 3000, 
    });
  };

  return { showSuccess, showError };
};

export default useToast;
